import { NavLink } from 'react-router-dom';
import { WhatsAppIcon } from '../../components/WhatsAppIcon';

// Link de navegacao no header global pra /atendimento, representado pelo
// icone WhatsApp. Visivel pra todos (admin, gerente, vendedor) — e a entrada
// principal do modulo de atendimento. Os controles admin (Conexao Baileys,
// Agentes, Horarios) ficam dentro do menu Configuracoes do Layout.
export function AdminAtendimentoMenu() {
  return (
    <NavLink
      to="/atendimento"
      className="btn-icon-header"
      title="Atendimento"
      aria-label="Atendimento"
      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <WhatsAppIcon size={24} />
    </NavLink>
  );
}
